import { useEffect, useRef } from 'react';
import lottie, { SVGRendererConfig } from 'lottie-web';

type Props = {
  animationData: unknown;
  className?: string;
  loop?: boolean;
  autoplay?: boolean;
  rendererSettings?: SVGRendererConfig;
};

export default function LottieWrapper(props: Props) {
  const {
    animationData,
    className,
    loop = false,
    autoplay,
    rendererSettings,
  } = props;

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const instance = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop,
      autoplay,
      animationData,
      rendererSettings,
    });

    return () => {
      instance.destroy();
    };
  }, [animationData, autoplay, loop, rendererSettings]);

  return <div ref={containerRef} className={className} />;
}
